import { render } from "./WIN_Evangelios.vue?vue&type=template&id=f6092c48"
import script from "./WIN_Evangelios.vue?vue&type=script&lang=js"
export * from "./WIN_Evangelios.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\evangelio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__